// extracted by mini-css-extract-plugin
export default {"snackContent":"Snack_snackContent__dx3gE"};